module.exports = __webpack_public_path__ + "static/focusbutton-1b224a9798c3b4d7d50d0642429100d1.png";